document.addEventListener('click', function(e) {
  if (e.target.closest('.minus_btn')) {
    setTimeout(() => { getCartInfo(); }, 100);
  }
  if (e.target.closest('.plus_btn')) {
    setTimeout(() => { getCartInfo(); }, 100);
  }
});

document.addEventListener('change', function(e) {
  if (e.target.matches('.number_val_input')) {
    setTimeout(() => { getCartInfo(); }, 100);
  }
});